import type { UserDto } from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";
import { useEffect } from "react";

import { axios } from "@/client/libs/axios";
import { useAuthStore } from "@/client/stores/auth";

export const fetchUser = async () => {
  console.log("开始获取用户数据");
  try {
    const response = await axios.get<UserDto | undefined, AxiosResponse<UserDto | undefined>>(
      "/user/me",
    );
    console.log("获取用户数据成功:", {
      userExists: !!response.data,
      userId: response.data?.id,
    });
    return response.data;
  } catch (error) {
    console.error("获取用户数据失败:", error);
    throw error;
  }
};

export const useUser = () => {
  const setUser = useAuthStore((state) => state.setUser);

  const {
    error,
    isPending: loading,
    data: user,
    refetch,
  } = useQuery({
    queryKey: ["user"],
    queryFn: fetchUser,
    staleTime: 5000, // 5秒内不重新获取数据
    refetchOnWindowFocus: false, // 窗口聚焦时不重新获取
  });

  // 记录用户状态变化
  useEffect(() => {
    console.log("用户状态变化:", {
      userExists: !!user,
      loading,
      userId: user?.id,
    });
    setUser(user ?? null);
  }, [user, setUser]);

  return { user: user, loading, error, refetch };
};
